import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "h-100 w-100" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  id: "vdom_editor",
  class: "w-100 h-100"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

import { onMounted, ref } from "vue";
import "brace";
import "brace/mode/javascript";
import "brace/mode/html";
import "brace/theme/chrome";
import { StringUtils } from "../../utils/StringUtils";
import { blocklyStore } from "../../blockly/blocklyStore";
import beautify from "js-beautify";
import { GlobalImport } from "../../utils/GlobalImport";

/**
 * エディタ生成
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'DynamicDomScriptSection',
  setup(__props) {

const editor = ref(null);
onMounted(() => {
  const beautifyOptions = {
    indent_size: 2, // インデントサイズ
    end_with_newline: true, // 最後に改行を含める
    preserve_newlines: false, // 改行を維持する
    max_preserve_newlines: 0, // 改行が連続した時に除去する
    wrap_line_length: 0, // 長い行で改行しない
    wrap_attributes_indent_size: 0, // 長い属性で改行しない
    extra_liners: "", // /htmlやbodyで改行しない
  };

  let vdom = blocklyStore.virtual_dom_js;
  vdom = beautify(vdom, beautifyOptions);
  const vdom_text = StringUtils.formatXml(vdom);

  editor.value = GlobalImport.getAce().edit("vdom_editor");
  editor.value.getSession().setMode("ace/mode/javascript");
  editor.value.setTheme("ace/theme/chrome");
  editor.value.setFontSize(18);
  editor.value.focus();
  editor.value.setReadOnly(true);
  editor.value.setValue(vdom_text);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}
}

})